import { GQL } from '@aline/graphql';

/**
 * Whether a workflow has left pre-signing. Signed and Complete count as sent, so
 * a workflow completed from the board without ever being sent locks its signer
 * fields the same way a signed one does.
 */
export function getIsWorkflowSentForSignature(
  workflow: Pick<GQL.Workflow, 'state'> | null
): boolean {
  if (!workflow) return false;

  switch (workflow.state) {
    case GQL.WorkflowState.Signing:
    case GQL.WorkflowState.Signed:
    case GQL.WorkflowState.Complete:
      return true;
    case GQL.WorkflowState.Negotiating:
    case GQL.WorkflowState.ReadyForSignature:
    case GQL.WorkflowState.Template:
      return false;
  }
}
